/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/render.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/


class LpRenderContent {
  constructor() {
    this.content = [];
    this.length = 0;
  }

  updateContent(cont, len = 0) {
    this.content = cont;
    this.length = len;
  }

  getContent() {
    return this.content;
  }

  getContentLength() {
    return this.length;
  }
}

export default LpRenderContent;



// WEBPACK FOOTER //
// ./src/app/indexes/render.js